import React from "react";
import * as token from "../services/commonMethods";

const ProtectedRoute = (props) => {
  const { Component } = props;
  React.useEffect(() => {
    console.log("protected route");
    if (!token.getCookie1("token")) {
      const appSource = localStorage.getItem("appSource");
      if (appSource && appSource == "shriram") {
        // do nothing for now
      } else {
        // window.location.replace(process.env.REACT_APP_USER_LOGIN_URL);
        const redirectedFrom = window.location;
        const base = process.env.REACT_APP_USER_LOGIN_URL;
        window.location.assign(base + '?redirected=' + window.btoa(redirectedFrom))
      }
    }
  }, []);
  return (
    <div>
      <Component />
    </div>
  );
};

export default ProtectedRoute;
